// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Scalars = require("../scalars/Scalars.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"startDateV2":{"c":"Scalars.PlainDateTime"},"":{"f":""}}};

var fragmentConverterMap = {
  "Scalars.PlainDateTime": Scalars.PlainDateTime.parse
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

var Utils = {};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ShowingsPageRelay_showing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDateV2",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShowingsPageRelayShowingsByDay_showings"
    }
  ],
  "type": "ShowingV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* Scalars Not a pure module */
